// extracted by mini-css-extract-plugin
export default {"image":"error-modal_image__CFqIf","container":"error-modal_container__3YQkj","title":"error-modal_title__J5Cze"};